import React, { useState, useEffect } from 'react';
import { uploadfiledata, updatedata, getdata, deletedata } from "../../util/global";
import { product } from './Datatype';

interface props {
  showmodal: string;
  setshowmodal: (modal: string) => void;
  formdata: product;
  setformdata: (data: product) => void;
  fetchdata: () => void;
}

const ProductForm: React.FC<props> = ({
  showmodal,
  setshowmodal,
  formdata,
  setformdata,
  fetchdata
}) => {
  const [selectedfiles, setselectedfiles] = useState<{ name: string; file: File }[]>([]);
  const [existingfiles, setexistingfiles] = useState<any[]>([]);

  const fetchexistingfiles = async () => {
    if (!formdata._id) {
      setexistingfiles([]);
      return;
    }
    const res = await getdata({
      filter: {
        _productid: formdata._id,
        filetype: "productfile",
        dbcollection: "appfiledata"
      }
    });
    setexistingfiles(res || []);
  };

  useEffect(() => {
    if (showmodal === "showproductform") {
      setselectedfiles([]);
      fetchexistingfiles();
    }
  }, [showmodal, formdata._id]);

  if (showmodal !== "showproductform") return null;

  const handlefilechange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const filesarray = Array.from(e.target.files || []);
    setselectedfiles(filesarray.map(file => ({ name: '', file })));
  };

  const deleterow = (index: number) => {
    setselectedfiles(selectedfiles.filter((_, i) => i !== index));
  };

  const handlerowchange = (index: number, val: string) => {
    const updated = [...selectedfiles];
    updated[index].name = val;
    setselectedfiles(updated);
  };

  const deletefile = async (fileid: string) => {
    if (!window.confirm("Are you sure you want to delete this file?")) return;
    const payload = { filter: { _id: fileid,datatype:"filedata", filetype: "productfile", dbcollection: "appfiledata" } };

    const result = await deletedata(payload);
    if (result.deletedcount > 0) {
      alert("File deleted successfully.");
      fetchexistingfiles();
      fetchdata();
    } else {
      alert("Failed to delete file.");
    }
  };

  const handlesave = async () => {
    const payload = {
      data: {
        ...formdata,
        datatype: "productdata"
      }
    };
    const res = await updatedata(payload);
    const targetproductid = formdata._id || res?.[0]?.id;

    if (selectedfiles.length > 0 && targetproductid) {
      const filenames = selectedfiles.map(item => item.name || item.file.name);
      const filebinaries = selectedfiles.map(item => item.file);

      const filepayload = {
        _adminuserid: window.APPSETTING?.adminuserid,
        _userid: window.APPUSER?.user?.userid,
        appname: window.APPSETTING?.appname,
        filetype: "productfile",
        parentid: JSON.stringify({ key: "_productid", value: targetproductid }),
        customfilenames: filenames,
        files: filebinaries
      };

      await uploadfiledata(filepayload);
    }

    setshowmodal("");
    fetchdata();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{formdata._id ? "edit product" : "add product"}</h3>
          <button className="close-btn" onClick={() => setshowmodal("")}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>name</label>
            <input 
              type="text" 
              className="form-input" 
              value={formdata.name || ''} 
              onChange={(e) => setformdata({ ...formdata, name: e.target.value })} 
            />
          </div>

          <div className="form-group">
            <label>sku</label>
            <input 
              type="text" 
              className="form-input" 
              value={formdata.sku || ''} 
              onChange={(e) => setformdata({ ...formdata, sku: e.target.value })} 
            />
          </div>

          <div className="form-group">
            <label>price</label>
            <input 
              type="number" 
              className="form-input" 
              value={formdata.price || ''} 
              onChange={(e) => setformdata({ ...formdata, price: e.target.value })} 
            />
          </div>

          <div className="form-group">
            <label>Deposit per unit (₹)</label>
            <input 
              type="number" 
              className="form-input" 
              value={formdata.deposit || ''} 
              onChange={(e) => setformdata({ ...formdata, deposit: e.target.value })} 
            />
          </div>

          <div className="form-group">
            <label>description</label>
            <textarea 
              className="form-input" 
              value={formdata.description || ''} 
              onChange={(e) => setformdata({ ...formdata, description: e.target.value })} 
            />
          </div>

          <div className="form-group">
            <label>status</label>
            <select 
              className="form-input"
              value={formdata.status || 'active'}
              onChange={(e) => setformdata({ ...formdata, status: e.target.value })}
            >
              <option value="active">active</option>
              <option value="inactive">inactive</option>
            </select>
          </div>

          <div className="form-group" style={{ marginTop: '15px' }}>
            <label>select product files</label>
            <input 
              type="file" 
              className="form-input" 
              multiple 
              onChange={handlefilechange}
            />
          </div>

          {selectedfiles.length > 0 && (
            <table className="grid" style={{ width: '100%', marginBottom: '15px' }}>
              <thead>
                <tr>
                  <th style={{ width: '40px' }}></th>
                  <th>description</th>
                  <th>filename</th>
                </tr>
              </thead>
              <tbody>
                {selectedfiles.map((row, i) => (
                  <tr key={i}>
                    <td>
                      <button onClick={() => deleterow(i)} style={{ color: 'red', border: 'none', background: 'none', cursor: 'pointer' }}>x</button>
                    </td>
                    <td>
                      <input 
                        type="text" 
                        className="form-input" 
                        placeholder="label" 
                        value={row.name} 
                        onChange={(e) => handlerowchange(i, e.target.value)} 
                      />
                    </td>
                    <td>{row.file.name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {formdata._id && existingfiles.length > 0 && (
            <div style={{ marginTop: '15px', marginBottom: '15px' }}>
              <label><strong>attached files</strong></label>
              <table className="grid" style={{ width: '100%', marginTop: '5px' }}>
                <thead>
                  <tr>
                    <th style={{ width: '40px' }}>action</th>
                    <th>description</th>
                    <th>filename</th>
                  </tr>
                </thead>
                <tbody>
                  {existingfiles.map((f, i) => (
                    <tr key={f._id || i}>
                      <td>
                        <button 
                          onClick={() => deletefile(f._id)} 
                          style={{ color: 'red', border: 'none', background: 'none', cursor: 'pointer' }}
                        >
                          x
                        </button>
                      </td>
                      <td>{f.displayname || '-'}</td>
                      <td>{f.filename}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <button className="btn-blue full-width" onClick={handlesave}>
            save product
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductForm;